require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-visual-design-use-a-bezier-curve-to-move-a-graphic.json") })
        }
      }, "path---responsive-web-design-applied-visual-design-use-a-bezier-curve-to-move-a-graphic");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-visual-design-use-a-bezier-curve-to-move-a-graphic!./.cache/json/responsive-web-design-applied-visual-design-use-a-bezier-curve-to-move-a-graphic.json
// module id = 2573
// module chunks = 231608221292675